import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { STATUS_CODE } from '../../../common/constants';
import { useSpinnerContext } from '../../../contexts/SpinnerContext';
import { useToastContext } from '../../../contexts/ToastContext';
import XacThucLayout from '../../../layouts/xac-thuc';
import apiService from '../../../services/api.service';
import '../index.scss';
import './index.scss';
function QuenMatKhauComponent() {
    const history = useHistory();
    const { showToast } = useToastContext();
    const { setIsShowLoading } = useSpinnerContext();
    const [email, setEmail] = useState('');
    const [userName, setUserName] = useState('');
    const [code, setCode] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setCofirmPassword] = useState('');
    const [step, setStep] = useState<'forgot' | 'otp' | 'password'>('forgot');
    const [id, setId] = useState<string>('');
    
    const handleForgotPassword = () => {
        if (!email) {
            showToast({ severity: 'error', summary: 'Thông báo', detail: 'Nhập tên tài khoản nhận mật khẩu', life: 3000 });
            return;
        }
        if (!userName) {
            showToast({ severity: 'error', summary: 'Thông báo', detail: 'Nhập Email nhận mật khẩu', life: 3000 });
            return;
        }
        setIsShowLoading(true);
        apiService.forgotPassgotRequest(email, userName)
            .then(function (response) {
                if (response.data.statusCode === STATUS_CODE.SUCCESS) {
                    setId(response.data.data.id);
                    // setIsShowLoading(true);
                    // apiService.sendMailAnyContent({
                    //     title: "Quên mật khẩu",
                    //     subject: "Quên mật khẩu",
                    //     emailFrom: "Học Hiệu Quả",
                    //     emailTo: email,
                    //     emailSubject: "Quên mật khẩu",
                    //     emailText: "Text",
                    //     content: `Mã xác nhận là: <b>${response.data.data.code}</b>. Vui lòng không chia sẻ mã này cho bất kì ai!`
                    // }).then(response1 => {
                    //     setStep('otp');
                    // })
                    // .catch(error => {
                    //     showToast({ severity: 'error', summary: 'Thông báo', detail: 'Gửi mail thất bại', life: 3000 });
                    //     console.log('SEnd email Fail:', error);
                    // })
                    // .finally(() => {
                    //     setIsShowLoading(false);
                    // })
                    setStep('otp');
                } else {
                    showToast({ severity: 'error', summary: 'Thông báo', detail: response.data.error, life: 3000 });
                }
            })
            .catch(function (error) {
                showToast({ severity: 'error', summary: 'Thông báo', detail: 'QUên mật khẩu thất bại', life: 3000 });
                console.error(error);
            })
            .finally(() => {
                setIsShowLoading(false);
            });
    }

    const handleVerifyCode = () => {
        if (!code) {
            showToast({ severity: 'error', summary: 'Thông báo', detail: 'Nhập mã CODE nhận được trng mail', life: 3000 });
            return;
        }
        setIsShowLoading(true);
        apiService.forgotPassgotVerify(id, code)
            .then(function (response) {
                if (response.data.statusCode === STATUS_CODE.SUCCESS) {
                   setStep('password');
                } else {
                    showToast({ severity: 'error', summary: 'Thông báo', detail: response.data.error, life: 3000 });
                }
            })
            .catch(function (error) {
                showToast({ severity: 'error', summary: 'Thông báo', detail: 'QUên mật khẩu thất bại', life: 3000 });
                console.error(error);
            })
            .finally(() => {
                setIsShowLoading(false);
            });
    }

    const handleSetPassword = () => {
        if (!password || !confirmPassword ) {
            showToast({ severity: 'error', summary: 'Thông báo', detail: 'Vui lòng nhập đầy đủ thông tin', life: 3000 });
            return;
        }
        if (password !== confirmPassword ) {
            showToast({ severity: 'error', summary: 'Thông báo', detail: 'Mật khẩu không trùng khớp', life: 3000 });
            return;
        }
        setIsShowLoading(true);
        apiService.changePasswordByEmail(email, password, userName)
            .then(function (response) {
                if (response.data.statusCode === STATUS_CODE.SUCCESS) {
                    showToast({ severity: 'success', summary: 'Thông báo', detail: 'Đặt mật khẩu thành công. Vui lòng đăng nhập', life: 3000 });
                    setTimeout(() => {
                        history.replace('/dang-nhap');
                    }, 2000);
                } else {
                    showToast({ severity: 'error', summary: 'Thông báo', detail: response.data.error, life: 3000 });
                }
            })
            .catch(function (error) {
                showToast({ severity: 'error', summary: 'Thông báo', detail: 'QUên mật khẩu thất bại', life: 3000 });
                console.error(error);
            })
            .finally(() => {
                setIsShowLoading(false);
            });
    }

    const generateForm = () => {
        if (step === 'forgot') {
            return (
                <div>
                    <div className="login-title">
                        <div className="login-title--left">
                            <h2> Quên mật khẩu </h2>
                        </div>
                        <div className="login-title--right">
                            <span className='subtitle'>Bạn đã có tài khoản?</span>
                            <span className='register-now' onClick={() => history.push('/dang-nhap')}>Đăng nhập ngay</span>
                        </div>
                    </div>
                    <div className="p-fluid login-form">
                        <div className="form-group">
                            <div className="label">Tài khoản đăng nhập <span className='text-red-500'> *</span></div>
                            <div className="input">
                                <i className="pi pi-users"></i>
                                <input type="userName" id="userName" name="userName" value={userName} onChange={(e: any) => setUserName(e.target.value)} autoFocus />
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="label">Email tài khoản <span className='text-red-500'> *</span></div>
                            <div className="input">
                                <i className="pi pi-envelope"></i>
                                <input type="email" id="email" name="email" value={email} onChange={(e: any) => setEmail(e.target.value)} />
                            </div>
                        </div>
                        <div className="login-actions">
                            <button type="button" onClick={() => handleForgotPassword()}>Gửi</button>
                        </div>
                    </div>
                </div>
            );
        } else if (step === 'otp') {
            return (
                <div>
                    <div className="login-title">
                        <div className="login-title--left">
                            <h2> Nhập mã xác thực </h2>
                        </div>
                    </div>
                    <div className="p-fluid login-form">
                        <div className="form-group">
                            <div className="label">Mã code nhận trong mail<span className='text-red-500'> *</span></div>
                            <div className="input">
                                <i className="pi pi-envelope"></i>
                                <input type="text" id="code" name="code" value={code}
                                    onChange={(e: any) => setCode(e.target.value)} autoFocus
                                    onKeyPress = {(e) => {
                                        if (e.key === 'Enter') {
                                            handleVerifyCode();
                                        }
                                    }}/>
                            </div>
                        </div>
                        <div className="login-actions">
                            <button type="button" onClick={() => handleVerifyCode()}>Xác nhận</button>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div>
                    <div className="login-title">
                        <div className="login-title--left">
                            <h2> Nhập mật khẩu mới </h2>
                        </div>
                    </div>
                    <div className="p-fluid login-form">
                        <div className="form-group">
                            <div className="label">Mật khẩu<span className='text-red-500'> *</span></div>
                            <div className="input">
                                <i className="pi pi-envelope"></i>
                                <input type="password" id="password" name="password" value={password}
                                    onChange={(e: any) => setPassword(e.target.value)} autoFocus
                                    onKeyPress = {(e) => {
                                        if (e.key === 'Enter') {
                                            handleSetPassword();
                                        }
                                    }}/>
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="label">Nhập lại mật khẩu<span className='text-red-500'> *</span></div>
                            <div className="input">
                                <i className="pi pi-envelope"></i>
                                <input type="password" id="confirmPassword" name="confirmPassword" value={confirmPassword}
                                onChange={(e: any) => setCofirmPassword(e.target.value)}
                                onKeyPress = {(e) => {
                                    if (e.key === 'Enter') {
                                        handleSetPassword();
                                    }
                                }}/>
                            </div>
                        </div>
                        <div className="login-actions">
                            <button type="button" onClick={() => handleSetPassword()}>Xác nhận</button>
                        </div>
                    </div>
                </div>
            )
        }
    }

    return (
        <div className='dang-nhap'>
            <XacThucLayout>
                <div className="login-wrapper">
                    {generateForm()}
                </div>
            </XacThucLayout>
        </div>
    );
}
export default QuenMatKhauComponent;